export class TransferListQuery {
    constructor(public Period?, public FromDate?, public ToDate?) { }
}